import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import XSpaceLoginEmbedder from '@ali/xspace-login-widget';
import STAR from './starbucks';
import classnames from 'classnames';
import util from './utils';
import styles from './app.css';
import i18nFunc from './i18n';

class Login extends Component {

   constructor(props){
       super(props);

       this.state = {
           loading:true
       }

       this.isStar = util.getParamFromUrl('from')==='starbucks';

       if(this.isStar)STAR();
   }

    componentDidMount() {
      
        let thirdLoginTypes = [];
        let isShowPhoneEmailLogin = false;

        const from = util.getParamFromUrl('from');

        let isFR = false;
        let redirectPath = '/alime.htm';
        if (location.pathname === '/login/loginWithAutoClose.htm') {
            isFR = true;
            redirectPath = '/login/loginWithAutoClose.htm?autoClose=true';
        }

        if (window.g_config &&
        window.g_config.thirdLoginTypes) {

        thirdLoginTypes = window.g_config.thirdLoginTypes;
        }

        if (window.g_config && window.g_config.isShowPhoneEmailLogin) {
        isShowPhoneEmailLogin = window.g_config.isShowPhoneEmailLogin;
        }
        const loginEmbedder = new XSpaceLoginEmbedder();
            loginEmbedder.render('login-frame-container', {
            theme: window.g_config.showOpenAccount ? 'bright' : 'dark',
            platformForm: from,
            ssoKey:'5512',
            lang: util.getDefaultLang(),
            redirectUrl: `${window.location.protocol}//${window.location.host}${redirectPath}`,
            width: window.g_config.showOpenAccount ? 330 : 380,
            height: window.g_config.showOpenAccount ? 230 : 280,
            supportUicAccount: !window.g_config.showOpenAccount,
            uicAccountConfig: {
                isFullRedirect: isFR
            },
            supportBucAccount: thirdLoginTypes.indexOf('buc') > -1,
            bucAccountConfig: {},
            supportOpenAccount: window.g_config.showOpenAccount,
            openAccountConfig: window.g_config.openAccountConfig,
            supportEmailPhoneLogin: isShowPhoneEmailLogin
        });
    }
    
    render() {
          let alimeLoginImg = {
              url:'//gw.alicdn.com/tfs/TB1MIztkYuWBuNjSszgXXb8jVXa-2560-1440.jpg',
              text1:'尖叫，从对话开始',
              text2:'Scream, start from conversation',
              logo:'AlimeBot Platform'
          }

          let starbucksImg = {
              url:'https://gw.alicdn.com/tfs/TB1cpItr5MnBKNjSZFCXXX0KFXa-1440-800.png',
              text1:'每人，每杯，每个社区',
              text2:'Everyone, every cup, every community',
              logo:'星巴克中国'
          }
          let loadAssets = this.isStar ?starbucksImg:alimeLoginImg;
          const { loading }  = this.state;

        return (
            <div className="alime-container">
               {
                this.isStar?<i className="alime-logo-star">{loadAssets.logo}</i>
                :<i className="alime-logo">{loadAssets.logo}</i>
               }
                <div className={classnames({
                'alime-login-iframe': true,
                'open-account-login-style': window.g_config.showOpenAccount
                })} id="login-frame-container"></div> 
               <div className="login-background">
                    <div className="carousel-item" style={{ backgroundImage: `url(${loadAssets.url})` }}>
                        <div className="carousel-text">
                        <p className="t1">{loadAssets.text1}</p>
                        <p className="t2">{loadAssets.text2}</p>
                        </div>
                    </div>
                </div>
                {
                    this.isStar?null:<p>Copyright © 2018 {'阿里巴巴 智能服务事业部'}</p>
                }
            </div>
        );
    }
}

ReactDOM.render(<Login></Login>,document.getElementById('root'));




// WEBPACK FOOTER //
// ./src/app.js